import { types } from "../types/types";

const initialState = {
  
  suggestCase : {},
  suggestCasesP: [],
  totalPagesP: 0,
  totalItemsP: 0,
  currentPageP: 0,
  loadingSuggestCase: false,
};
export const suggestCaseReducer = (state = initialState, action) => {
  switch (action.type) {
  
    case types.SUGGEST_CASE_START_LOADING_PAGINATED:
      return {
        ...state,
        suggestCasesP: action.payload.suggestCasesP,
        totalItemsP: action.payload.totalItems,
        totalPagesP: action.payload.totalPages,
        currentPageP: action.payload.currentPage,
      };

    case types.SUGGEST_CASE_CLEAN:
      return {
        ...state,
        suggestCasesP: [],
      };
      case types.SUGGEST_CASE_START_LOADING:
        return {
          ...state,
          loadingSuggestCase: true,
        };

      case types.SUGGEST_CASE_STOP_LOADING:
        return {
          ...state,
          loadingSuggestCase: false,
        };

    default:
      return state;
  }
};
